import { useQuery } from '@tanstack/react-query';

import { fetchSellerStatusApiRequest } from '../api';

import { RQ_SELLER_STATUS } from '@/modules/ReactQuery/cacheKeys';

type UseSellerStatusQueryOptions = {
  refetchOnMount?: boolean | 'always';
};

export function useFetchSellerOnboardingStatus(
  userId?: number,
  { refetchOnMount }: UseSellerStatusQueryOptions = {}
) {
  return useQuery({
    queryFn: fetchSellerStatusApiRequest,
    queryKey: [RQ_SELLER_STATUS],
    enabled: Boolean(userId),
    refetchOnMount,
  });
}
